export const OPS_DETAIL = {
  calendar: 'Operasyon takvimi', calendarHint: 'Konaklamalar, transferler ve turlar bir arada.',
  today: 'Bugün', previous: 'Önceki dönem', next: 'Sonraki dönem', date: 'Tarihe git',
  month: 'Ay', week: 'Hafta', day: 'Gün', agenda: 'Ajanda', timezone: 'Dubai saati · GMT+4',
  allDay: 'Gün boyu', undated: 'Tarihi belirlenmemiş', noEvents: 'Bu gün için planlanmış hizmet yok.',
  noUndated: 'Tüm hizmetlerin tarihi belirlenmiş.', loading: 'Takvim yükleniyor…',
  error: 'Takvim yüklenemedi.', retry: 'Yeniden dene', close: 'Kapat',
  event: 'Hizmet ayrıntıları', customer: 'Misafir', supplier: 'Tedarikçi', order: 'Sipariş', status: 'Görev durumu',
  weekdays: ['Pzt', 'Sal', 'Çar', 'Per', 'Cum', 'Cmt', 'Paz'],
  filters: 'Hizmet türleri', allTypes: 'Tüm hizmetler', hotel: 'Konaklama', tour: 'Tur', transfer: 'Transfer', other: 'Diğer',
  more: (count: number) => `+${count} hizmet daha`, count: (count: number) => `${count} hizmet`,
  view: 'Takvim görünümü', selectedDay: 'Seçili gün',
  orderTitle: 'Sipariş çalışma alanı', orderHint: 'Siparişi seçin, sıradaki adımla ilerleyin.',
  prep: 'Hazırlık', booking: 'Rezervasyon', confirmation: 'Teyit', voucher: 'Belge', done: 'Tamamlandı',
  nextStep: 'Sıradaki işlem', allActions: 'Diğer işlem adımları',
  bookingDetails: 'Rezervasyon bilgileri', management: 'Atama, öncelik ve engeller',
  guestInfo: 'Misafir ve rezervasyon', taskCount: (n: number) => `${n} görev`,
  originalProduct: 'Asıl ürün', catalogueCode: 'Ürün kodu', quotedProduct: 'Teklif adı', salesNote: 'Satış notu',
  notes: 'Notlar', files: 'Dosyalar', upload: 'Dosya seç', uploadHint: 'PDF, PNG, JPG veya TXT',
  noFile: 'Yüklenecek dosyayı seçin', removeFile: 'Seçimi kaldır',
  visaHint: 'Başvuruları durumlarına göre takip edin ve sonuçlandırın.', search: 'Vize taleplerinde ara',
  searchHint: 'Sipariş veya başvuran ara', results: (n: number) => `${n} başvuru`,
  noTasks: 'Bu seçimde gösterilecek görev bulunmuyor.',
} as const;
